
namespace Matrix.Indexation {
    export class FactIndexPriceColumns {
        static columnsKey = 'Indexation.FactIndexPrice';
    }
}